export default class RandomPool {

	constructor(array, randomizeWhenEmpty = true) {
		this.originalArray = array;
		this.randomizeWhenEmpty = randomizeWhenEmpty;

		this.randomArray = [];
		this.currentArray = [];

		// build new random pool

		this.restock();
	}

	restock() {
		if (!this.randomArray.length || this.randomizeWhenEmpty) {
			this.randomize();
		} else {
			this.currentArray = this.randomArray.concat();
		}
	}

	randomize() {
		this.randomArray = this.getRandomArray(this.originalArray);
		// make copy so original random order is preserved
		this.currentArray = this.randomArray.concat();
	}

	getRandomArray(array) {
		const arrayCopy = array.concat();
		const returnArray = [];

		let i = arrayCopy.length - 1;
		while (i >= 0) {
			const index = Math.round(Math.random() * i);
			returnArray.push(arrayCopy[index]);
			arrayCopy.splice(index, 1);
			i--;
		}

		return returnArray;
	}

	getItem() {
		if (!this.currentArray.length) {
			this.restock();
		}
		return this.currentArray.splice(0, 1)[0];
	}

	// reset array

	setArray(array) {
		this.originalArray = array;
		this.restock();
	}

}

